import type { EmptyReturnBoardItem } from '@chukua/common';

/** "Today", "3 days" or "2 days overdue" — the board's countdown column. */
export function describeDaysRemaining(daysRemaining: number): string {
  if (daysRemaining === 0) return 'Today';
  const days = Math.abs(daysRemaining);
  const unit = days === 1 ? 'day' : 'days';
  return daysRemaining < 0 ? `${days} ${unit} overdue` : `${days} ${unit}`;
}

/** Levels are admin-configured and carry no colour of their own, so urgency comes from the threshold: the deadline day or past it is an error, anything earlier a warning. */
export function levelTagColor(level: EmptyReturnBoardItem['level']): 'error' | 'warning' | 'default' {
  if (!level) return 'default';
  return level.daysThreshold <= 0 ? 'error' : 'warning';
}
